var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMealCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2973 6.37777H14.8918C14.8918 5.33921 14.5229 4.78577 14.2264 4.34114C13.987 3.98196 13.8288 3.74476 13.8288 3.18889C13.8288 2.63301 13.987 2.39581 14.2264 2.03664C14.5229 1.592 14.8918 1.03862 14.8918 0H13.2973C13.2973 0.555823 13.1391 0.793076 12.8998 1.15225C12.6033 1.59689 12.2344 2.15027 12.2344 3.18889C12.2344 4.22751 12.6033 4.78088 12.8998 5.22552C13.1391 5.5847 13.2973 5.8219 13.2973 6.37777Z",
    fill: "url(#paint0_linear_740_6201)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3442 9.56723H19.9387C19.9387 8.5286 19.5698 7.97523 19.2732 7.53059C19.0338 7.17147 18.8757 6.93422 18.8757 6.37834C18.8757 5.82246 19.0339 5.58526 19.2732 5.22609C19.5698 4.78145 19.9387 4.22802 19.9387 3.18945H18.3442C18.3442 3.74533 18.186 3.98253 17.9467 4.3417C17.6502 4.78634 17.2812 5.33977 17.2812 6.37834C17.2812 7.41691 17.6502 7.97034 17.9467 8.41497C18.186 8.77415 18.3442 9.0114 18.3442 9.56723Z",
    fill: "url(#paint1_linear_740_6201)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16797 9.56723H8.76241C8.76241 9.0114 8.92063 8.77415 9.16001 8.41497C9.45647 7.97034 9.82537 7.41696 9.82537 6.37834C9.82537 5.33972 9.45647 4.78634 9.16001 4.3417C8.92063 3.98253 8.76241 3.74533 8.76241 3.18945H7.16797C7.16797 4.22802 7.53687 4.78145 7.83338 5.22609C8.07276 5.58521 8.23093 5.82246 8.23093 6.37834C8.23093 6.93422 8.07271 7.17141 7.83338 7.53059C7.53687 7.97523 7.16797 8.5286 7.16797 9.56723Z",
    fill: "url(#paint2_linear_740_6201)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.322V23.9165H1.89893L3.49337 27.1054H23.6121L25.2065 23.9165H27.1055V22.322C23.3829 22.322 3.74242 22.322 0 22.322Z",
    fill: "url(#paint3_linear_740_6201)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9414 12.2156V11.9581C15.9414 10.6393 14.8686 9.56641 13.5498 9.56641C12.2284 9.56641 11.1581 10.6365 11.1581 11.9581V12.2156C6.94206 13.1383 3.58836 16.4418 2.64844 20.7275H24.4511C23.5116 16.444 20.1595 13.1388 15.9414 12.2156Z",
    fill: "url(#paint4_linear_740_6201)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_6201",
    x1: 12.8492,
    y1: 3.60593,
    x2: 14.8727,
    y2: 3.60573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_6201",
    x1: 17.8961,
    y1: 6.79538,
    x2: 19.9196,
    y2: 6.79518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_6201",
    x1: 7.78281,
    y1: 6.79538,
    x2: 9.80628,
    y2: 6.79518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_6201",
    x1: 6.27135,
    y1: 25.0265,
    x2: 26.9107,
    y2: 24.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_6201",
    x1: 7.69288,
    y1: 15.8768,
    x2: 24.2944,
    y2: 15.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealCard);
export default __webpack_public_path__ + "static/media/meal-card.28a855738099273cbf6123e0063ab3c5.svg";
export { ForwardRef as ReactComponent };